export default __webpack_public_path__ + "static/media/logo.271219da.png";